import { jsx as l, jsxs as a } from "react/jsx-runtime";
import "react";
var Z = (h) => /* @__PURE__ */ a("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...h,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M1.985 11.304A19.921 19.921 0 0 0 0 20c0 3.116.713 6.066 1.985 8.696L20 30.435l18.016-1.74A19.92 19.92 0 0 0 40 20c0-3.116-.713-6.066-1.984-8.696L20 9.565l-18.015 1.74Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#6DA544",
      d: "M1.985 28.696C5.22 35.386 12.071 40 20 40c7.93 0 14.78-4.614 18.015-11.304H1.985Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M1.985 11.304h36.03C34.78 4.614 27.929 0 20 0 12.07 0 5.22 4.615 1.985 11.304Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M16.522 25.218h6.956V22.26l-1.391.696L20 20.87l-2.087 2.087-1.391-.696v2.957Zm-3.981-3.478.324.995h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048l.323-.996Zm1.004-3.48.324.997h1.048l-.848.616.324.996-.848-.615-.847.615.323-.996-.847-.616h1.048l.323-.996Zm2.87-2.608.324.997h1.047l-.847.616.324.996-.848-.616-.847.616.323-.996-.847-.616h1.047l.324-.997Zm11.043 6.088-.323.995h-1.048l.848.616-.324.997.847-.616.848.616-.324-.997.848-.616h-1.048l-.324-.996Zm-1.003-3.48-.324.997h-1.048l.848.616-.324.996.848-.615.847.615-.324-.996.848-.616h-1.048l-.323-.996Zm-2.87-2.608-.324.997h-1.047l.847.616-.324.996.848-.616.848.616-.324-.996.847-.616H23.91l-.324-.997ZM20 14.348l.324.996h1.047l-.847.616.324.996-.848-.615-.848.615.324-.996-.848-.616h1.048l.324-.996Z"
    })
  ]
});
export {
  Z as default
};
